import {
  Component,
  ChangeDetectionStrategy,
  forwardRef,
  viewChild,
  input,
  booleanAttribute,
  inject,
  output,
  OnInit,
} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { ScrollPickerDirective } from '@cue/utilities';
import {
  DateTimePickerModule,
  TimePickerComponent,
  TimePickerIncrementalSteps,
  TimePickerModule,
} from '@progress/kendo-angular-dateinputs';
import { TranslocoPipe } from '@jsverse/transloco';
import { translation } from '@cue/translations';
import { FloatingLabelComponent } from '@progress/kendo-angular-label';

@Component({
  selector: 'assist-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TimePickerModule, DateTimePickerModule, ReactiveFormsModule, TranslocoPipe, ScrollPickerDirective],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimepickerComponent),
      multi: true,
    },
  ],
})
export class TimepickerComponent implements ControlValueAccessor, OnInit {
  public floatingLabel = inject(FloatingLabelComponent, { optional: true });
  private controlContainer = inject(ControlContainer, { optional: true, host: true, skipSelf: true });
  showClear = input<boolean, boolean | string>(false, {
    transform: booleanAttribute,
  });
  inputFocus = output();
  steps = input<TimePickerIncrementalSteps>();
  format = input('HH:mm');
  appendTo = input<any>('component');
  kendoPicker = viewChild(TimePickerComponent);
  min = input<Date>();
  max = input<Date>();
  popupClass = input('assist-timepicker-popup');
  translation = translation;
  private _ignoreEmit: boolean = false;
  onChange: any = (val) => {};
  onTouch: any = (val) => {};
  _control = new FormControl<Date>(null);

  ngOnInit() {
    this._control.valueChanges.subscribe((val) => {
      if (this._ignoreEmit) {
        this._ignoreEmit = false;
      } else {
        this.onChange(val);
      }
    });
  }

  open() {
    this.kendoPicker().toggle(true);
  }

  focus() {
    this.onTouch();
    if (this.floatingLabel) {
      this.floatingLabel.focused = true;
    }
  }

  blur() {
    if (this.floatingLabel) {
      this.floatingLabel.focused = false;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: any): void {
    this._ignoreEmit = true;
    this._control.setValue(obj);
  }

  protected readonly event = event;
}
